import { Platform, TextStyle } from "react-native";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";

// Define your styles
export const { ids, styles } = StyleSheet.create({
  infoMessage: {
    fontFamily: theme.fontFamily.robotoRegular,
    paddingLeft: theme.spacing.lg,
    color: theme.colors.white,
  },
  passwordContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  infoIcon: {
    width: 13.2,
    height: 13.2,
    position: "absolute",
    top: 3,
  },
  nameBlock: {
    "@media (min-width: 200px)": {
      flexDirection: "column",
    },
    "@media (min-width: 700px)": {
      flexDirection: "row",
    },
  },
  loginLink: {
    color: theme.colors.white,
    textDecorationLine: "underline",
    fontFamily: theme.fontFamily.robotoRegular,
    fontSize: theme.fontsize.cs,
    fontWeight: theme.fontweight.regular as TextStyle["fontWeight"],
  },
  whiteText: {
    fontFamily: theme.fontFamily.robotoRegular,
    color: theme.colors.white,

    fontSize: theme.fontsize.cs,
  },
  loginHere: {
    textAlign: "center",
    justifyContent: "center",
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  twoColLayout: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
          marginTop: theme.margin.xxs,
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
          marginTop: theme.margin.xxs,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
          marginTop: theme.margin.sm,
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
          marginTop: theme.margin.sm,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          minWidth: "100%",
          maxWidth: "100%",
        },
        "@media (min-width: 700px)": {
          minWidth: "50%",
          maxWidth: "50%",
        },
      },
    }),
  },
  colOne: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingRight: 0,
        },
        "@media (min-width: 600px)": {
          paddingRight: theme.spacing.sm,
        },
      },
    }),
  },
  colTwo: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 600px)": {
          paddingLeft: theme.spacing.sm,
        },
      },
    }),
  },
  formGroup: {
    width: "100%",
    marginBottom: theme.margin.md,
  },
  showPassowrd: {
    position: "absolute",
    right: 10,
    // top: 36,
    color: theme.colors.white,
    height: 32,
    // width: 44,
    justifyContent: "center",
    alignItems: "center",
  },
  input: {
    height: 40,
    backgroundColor: theme.colors.white + 20,
    padding: theme.spacing.ssm,
    width: "100%",
    minWidth: "100%",
    maxWidth: "100%",
    paddingRight: theme.spacing.reg,
    borderRadius: theme.radius.xxs,
    borderWidth: 0,
    color: theme.colors.white,
  },
  passwordInput: {
    height: 40,
    backgroundColor: theme.colors.white + 20,
    padding: theme.spacing.ssm,
    width: "100%",
    minWidth: "100%",
    maxWidth: "100%",
    paddingRight: 60,
    borderRadius: theme.radius.xxs,
    borderWidth: 0,
    color: theme.colors.white,
  },
  inputRed: {
    height: 40,
    backgroundColor: theme.colors.errorRed + 60,
    padding: theme.spacing.ssm,
    width: "100%",
    maxWidth: "100%",
    paddingRight: "5%",
    minWidth: "100%",
    borderRadius: theme.radius.xxs,
    borderWidth: 0,
    color: theme.colors.white,
  },
  inputLabel: {
    marginBottom: theme.margin.sm,
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoBold,
    fontWeight: theme.fontweight.bold as any,
    fontSize: theme.fontsize.cs,
  },
  errorContainer: {
    marginBottom: theme.margin.ssm,
    alignContent: "center",
  },
  passwordErrorContainer: {
    position: "relative",
    marginBottom: 0,
  },
  errorMessage: {
    color: theme.colors.errorRed,
    marginTop: theme.margin.xxs,
    position: "absolute",
    fontSize: theme.fontsize.sm,
  },
  hintMessage: {
    color: theme.colors.white,
    marginTop: theme.margin.xxs,
    position: "absolute",
    fontFamily: theme.fontFamily.robotoRegular,
    fontSize: theme.fontsize.sm,
  },
  passwordMessage: {
    color: theme.colors.errorRed,
    marginTop: theme.margin.xxs,
    fontSize: theme.fontsize.sm,
  },
  passwordMessageError: {
    color: theme.colors.white,
    fontSize: theme.fontsize.sm,
  },
  makeaPaymentBtn: {
    minWidth: "100%",
    backgroundColor: theme.colors.button.primary,
    padding: theme.spacing.reg,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: theme.radius.sm,
    marginTop: theme.margin.lg,
    marginBottom: theme.margin.xlg,
    fontWeight: theme.fontweight.medium as any,
  },
  btnText: {
    fontFamily: theme.fontFamily.robotoBold,
    fontWeight: theme.fontweight.medium as any,
    color: theme.colors.white,
    fontSize: theme.fontsize.md,
  },
});
